import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { hasMany } from 'ember-data/relationships';

import MessageItemModel from 'cio/models/message-item';
import { modelApiAction } from 'cio/utils/model-api-actions';

export enum UsageCountType {
  Campaigns = 'campaigns',
  Broadcasts = 'broadcasts',
  Transactional = 'transactional',
}

export default class Snippet extends Model {
  @attr('string') name!: string;
  @attr('string') value!: string;
  @attr('date') updatedAt!: Date;
  @attr('boolean') inUse!: boolean;
  @attr('boolean') usageLoaded!: boolean;

  @hasMany('message-item', { async: false, inverse: null }) messageItems!: MessageItemModel[];

  get usageCounts(): Record<UsageCountType, number> {
    let { campaignIds, broadcastIds, transactionalIds } = this.messageItems.reduce<Record<string, string[]>>(
      (acc, item) => {
        if (item.belongsToCampaign) {
          acc.campaignIds = [...new Set([...acc.campaignIds, item.campaignId])];
        } else if (item.belongsToNewsletter) {
          acc.broadcastIds = [...new Set([...acc.broadcastIds, item.newsletterId])];
        } else if (item.belongsToTransactional) {
          acc.transactionalIds = [...new Set([...acc.transactionalIds, item.transactionalMessageId])];
        }

        return acc;
      },
      { campaignIds: [], broadcastIds: [], transactionalIds: [] },
    );
    return { campaigns: campaignIds.length, broadcasts: broadcastIds.length, transactional: transactionalIds.length };
  }

  fetchUsage = modelApiAction({
    type: 'GET',
    path(this: Snippet, { continuation }: { continuation: number }) {
      return `usage/${continuation}`;
    },
    before(this: Snippet, { continuation: _, ...rest }: Record<string, any>) {
      return rest;
    },
    after(this: Snippet, { snippet, message_items, continuation, more }) {
      this.store.pushPayload({ snippet: { ...snippet, id: this.id }, message_items });
      return { continuation, more };
    },
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    snippet: Snippet;
  }
}
